module.exports = "https://img.zhijierongxing.com/saas/img/activity_income.d7ede235.png";